(ns frontend.ui.component.lp-portal.report.company.overview.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]))

(defn board
  []
  {:padding "8px 0px"})

(defn board-title
  []
  {:font-style :italic
   :color      (color [:text-strong :primary :color])})
